<div
    class="relative flex min-h-screen w-full items-center justify-center p-4 py-8 sm:p-6 lg:p-10"
    style="
        background: linear-gradient(
            180deg,
            #f8fafc 0%,
            #eef1f6 50%,
            #e9eef5 100%
        );
    "
>
    <!-- Centered Max-Width Container in Middle of Screen -->
    <div
        class="mx-auto flex w-full max-w-6xl items-center justify-between gap-8 lg:gap-12 xl:max-w-[96rem] xl:gap-16"
    >
        <!-- Left Hero & Brand Showcase (Desktop) -->
        <div
            class="relative hidden flex-col justify-center space-y-8 lg:flex lg:w-5/12"
        >
            <!-- Hero Content & Copy -->
            <div class="relative z-10 max-w-xl space-y-6">
                <!-- Brand Logo with Rounded White Background -->
                <div>
                    <a
                        routerLink="/"
                        class="inline-flex items-center justify-center rounded-2xl border border-slate-200/90 bg-white p-3 shadow-xs transition-all duration-200 hover:scale-[1.02] hover:border-slate-300 hover:shadow-sm"
                    >
                        <img
                            src="assets/images/cjc.svg"
                            alt="Chakrijibi Club Logo"
                            class="h-11 w-auto object-contain md:h-12"
                        />
                    </a>
                </div>

                <!-- Tag / Badge -->
                <div
                    class="inline-flex items-center gap-2 rounded-full border border-sky-200/80 bg-sky-50 px-3.5 py-1.5 text-xs font-semibold text-[#1587e8] shadow-xs"
                >
                    <ng-icon
                        name="lucideSparkles"
                        class="h-3.5 w-3.5 text-[#1587e8]"
                    />
                    <span>Corporate Benefit Ecosystem</span>
                </div>

                <h1
                    class="font-secondary text-3xl leading-snug font-extrabold tracking-tight text-[#0f172a] sm:text-4xl"
                >
                    Unlock verified perks, <br />
                    <span
                        class="bg-gradient-to-r from-[#0284c7] to-[#0f6ebd] bg-clip-text text-transparent"
                        >exclusive discounts</span
                    >
                    & rewards.
                </h1>

                <p class="text-sm leading-relaxed text-slate-600 sm:text-base">
                    Your company-partnered portal for top-tier discounts on
                    dining, electronics, lifestyle, travel, and wellness. Claim
                    offers seamlessly on any device.
                </p>

                <!-- Feature Highlight Cards (Light theme) -->
                <div class="grid grid-cols-1 gap-3 pt-2 sm:grid-cols-3">
                    <div
                        class="rounded-2xl border border-slate-200/90 bg-white/85 p-3.5 shadow-xs backdrop-blur-xs transition-all hover:bg-white hover:shadow-sm"
                    >
                        <div
                            class="mb-2 flex h-8 w-8 items-center justify-center rounded-xl bg-sky-50 text-[#1587e8]"
                        >
                            <ng-icon name="lucideTag" class="h-4 w-4" />
                        </div>
                        <h3 class="text-xs font-bold text-[#0f172a]">
                            500+ Brands
                        </h3>
                        <p
                            class="mt-0.5 text-[11px] leading-tight text-slate-500"
                        >
                            Top national & global merchants
                        </p>
                    </div>

                    <div
                        class="rounded-2xl border border-slate-200/90 bg-white/85 p-3.5 shadow-xs backdrop-blur-xs transition-all hover:bg-white hover:shadow-sm"
                    >
                        <div
                            class="mb-2 flex h-8 w-8 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600"
                        >
                            <ng-icon name="lucideSparkles" class="h-4 w-4" />
                        </div>
                        <h3 class="text-xs font-bold text-[#0f172a]">
                            Up to 60% Off
                        </h3>
                        <p
                            class="mt-0.5 text-[11px] leading-tight text-slate-500"
                        >
                            Corporate member rates
                        </p>
                    </div>

                    <div
                        class="rounded-2xl border border-slate-200/90 bg-white/85 p-3.5 shadow-xs backdrop-blur-xs transition-all hover:bg-white hover:shadow-sm"
                    >
                        <div
                            class="mb-2 flex h-8 w-8 items-center justify-center rounded-xl bg-blue-50 text-blue-600"
                        >
                            <ng-icon name="lucideShieldCheck" class="h-4 w-4" />
                        </div>
                        <h3 class="text-xs font-bold text-[#0f172a]">
                            Instant Claim
                        </h3>
                        <p
                            class="mt-0.5 text-[11px] leading-tight text-slate-500"
                        >
                            Digital vouchers & codes
                        </p>
                    </div>
                </div>
            </div>

            <!-- Trust Footer -->
            <div
                class="flex items-center justify-between border-t border-slate-200/80 pt-5 text-xs text-slate-400"
            >
                <p>&copy; 2026 ChakrijibiClub. All rights reserved.</p>
                <div class="flex items-center gap-1.5 text-slate-500">
                    <ng-icon
                        name="lucideShieldCheck"
                        class="h-4 w-4 text-emerald-600"
                    />
                    <span>256-Bit SSL Encrypted</span>
                </div>
            </div>
        </div>

        <!-- Right Form Section -->
        <div
            class="relative flex w-full flex-col items-center justify-center lg:w-7/12"
        >
            <!-- Mobile Logo Bar -->
            <div class="flex w-full items-center pb-4 lg:hidden">
                <a
                    routerLink="/"
                    class="inline-flex items-center justify-center rounded-xl border border-slate-200/90 bg-white p-2 shadow-xs transition-transform hover:scale-[1.02]"
                >
                    <img
                        src="assets/images/cjc.svg"
                        alt="Chakrijibi Club Logo"
                        class="h-8 w-auto object-contain"
                    />
                </a>
            </div>

            <!-- Centered Login Card with INCREASED WIDTH (max-w-xl) -->
            <div class="mx-auto my-auto w-full max-w-xl py-6">
                <div
                    class="relative overflow-hidden rounded-3xl border border-slate-200/90 bg-white p-8 shadow-xl shadow-slate-200/60 sm:p-10 md:p-12"
                >
                    <!-- Top Accent Line -->
                    <div
                        class="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-b from-[#1587e8] to-[#0f6ebd] shadow-[0_4px_14px_0_rgb(21,135,232,0.39)] ring-1 ring-white/20 transition-all duration-200 ring-inset hover:shadow-[0_6px_20px_rgba(21,135,232,0.23)] hover:brightness-110 active:scale-[0.98]"
                    ></div>

                    <!-- Card Header -->
                    <div class="mb-8 space-y-2 text-left">
                        <h2
                            class="font-secondary text-2xl font-bold tracking-tight text-[#0f172a] sm:text-3xl"
                        >
                            Welcome back
                        </h2>
                        <p class="text-sm text-slate-500">
                            Sign in to access your employee perks and deals
                        </p>
                    </div>

                    <!-- Error Alert Banner -->
                    @if (errorMessage()) {
                        <div
                            class="mb-6 flex items-start gap-3 rounded-2xl border border-red-200 bg-red-50/90 p-4 text-sm text-red-700 shadow-xs"
                        >
                            <ng-icon
                                name="lucideAlertCircle"
                                class="mt-0.5 h-5 w-5 shrink-0 text-red-600"
                            />
                            <div class="flex-1 leading-relaxed font-medium">
                                {{ errorMessage() }}
                            </div>
                        </div>
                    }

                    <!-- Login Form -->
                    <form
                        [formGroup]="loginFormService.form"
                        (ngSubmit)="onSubmit()"
                        class="space-y-5"
                    >
                        <!-- Email Field -->
                        <div class="space-y-1.5">
                            <label
                                for="identifier"
                                class="block text-xs font-semibold tracking-wide text-slate-700 uppercase"
                            >
                                Email Address
                                <span class="text-red-500">*</span>
                            </label>
                            <div class="relative flex items-center">
                                <span
                                    class="pointer-events-none absolute left-3.5 text-slate-400"
                                >
                                    <ng-icon
                                        name="lucideMail"
                                        class="h-5 w-5"
                                    />
                                </span>
                                <input
                                    id="identifier"
                                    type="email"
                                    placeholder="name@company.com"
                                    formControlName="identifier"
                                    autocomplete="email"
                                    class="w-full rounded-xl border border-slate-200 bg-slate-50/70 py-3 pr-4 pl-11 text-sm text-slate-900 transition-all outline-none placeholder:text-slate-400 hover:border-slate-300 focus:border-[#1587e8] focus:bg-white focus:ring-4 focus:ring-[#1587e8]/10"
                                />
                            </div>
                            @if (
                                loginFormService.identifier?.invalid &&
                                loginFormService.identifier?.touched
                            ) {
                                <p class="text-xs font-medium text-red-600">
                                    Please enter a valid corporate email
                                    address.
                                </p>
                            }
                        </div>

                        <!-- Password Field -->
                        <div class="space-y-1.5">
                            <div class="flex items-center justify-between">
                                <label
                                    for="password"
                                    class="block text-xs font-semibold tracking-wide text-slate-700 uppercase"
                                >
                                    Password <span class="text-red-500">*</span>
                                </label>
                                <a
                                    routerLink="/forgot-password"
                                    class="text-xs font-semibold text-[#1587e8] transition-colors hover:text-[#0f6ebd] hover:underline"
                                >
                                    Forgot password?
                                </a>
                            </div>
                            <div class="relative flex items-center">
                                <span
                                    class="pointer-events-none absolute left-3.5 text-slate-400"
                                >
                                    <ng-icon
                                        name="lucideLock"
                                        class="h-5 w-5"
                                    />
                                </span>
                                <input
                                    id="password"
                                    [type]="inputType()"
                                    placeholder="••••••••"
                                    formControlName="password"
                                    autocomplete="current-password"
                                    class="w-full rounded-xl border border-slate-200 bg-slate-50/70 py-3 pr-11 pl-11 text-sm text-slate-900 transition-all outline-none placeholder:text-slate-400 hover:border-slate-300 focus:border-[#1587e8] focus:bg-white focus:ring-4 focus:ring-[#1587e8]/10"
                                />
                                <button
                                    type="button"
                                    (click)="togglePasswordVisibility()"
                                    [disabled]="isSubmitting()"
                                    class="absolute right-2.5 flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600 focus:outline-hidden"
                                    [title]="
                                        inputType() === 'password'
                                            ? 'Show password'
                                            : 'Hide password'
                                    "
                                >
                                    <ng-icon [name]="icon()" class="h-4 w-4" />
                                    <span class="sr-only"
                                        >Toggle password visibility</span
                                    >
                                </button>
                            </div>
                            @if (
                                loginFormService.password?.invalid &&
                                loginFormService.password?.touched
                            ) {
                                <p class="text-xs font-medium text-red-600">
                                    Password is required to sign in.
                                </p>
                            }
                        </div>

                        <!-- Remember Me Option -->
                        <div class="flex items-center pt-1">
                            <label
                                class="group flex cursor-pointer items-center gap-2.5 text-sm select-none"
                            >
                                <input
                                    type="checkbox"
                                    [checked]="rememberMe()"
                                    (change)="toggleRememberMe()"
                                    class="h-4 w-4 rounded border-slate-300 text-[#1587e8] transition focus:ring-[#1587e8]"
                                />
                                <span
                                    class="text-xs font-medium text-slate-600 transition group-hover:text-slate-900"
                                >
                                    Keep me signed in on this device
                                </span>
                            </label>
                        </div>

                        <!-- Primary Action Button -->
                        <button
                            type="submit"
                            [disabled]="isSubmitting()"
                            class="hover: mt-2 flex w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-gradient-to-b from-[#1587e8] to-[#0f6ebd] py-3.5 text-sm font-semibold text-white shadow-[0_4px_14px_0_rgb(21,135,232,0.39)] ring-1 ring-white/20 transition-all duration-200 ring-inset hover:shadow-[0_6px_20px_rgba(21,135,232,0.23)] hover:brightness-110 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60"
                        >
                            @if (isSubmitting()) {
                                <svg
                                    class="h-4 w-4 animate-spin text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        class="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        stroke-width="4"
                                    ></circle>
                                    <path
                                        class="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                </svg>
                                <span>Signing In...</span>
                            } @else {
                                <span>Sign In</span>
                                <ng-icon
                                    name="lucideArrowRight"
                                    class="h-4 w-4 transition-transform group-hover:translate-x-0.5"
                                />
                            }
                        </button>
                    </form>
                </div>

                <!-- Footer Sign-up Prompt -->
                <p class="mt-8 text-center text-sm text-slate-500">
                    Don't have an account yet?
                    <a
                        routerLink="/register"
                        class="font-semibold text-[#1587e8] transition-colors hover:text-[#0f6ebd] hover:underline"
                    >
                        Sign up for benefits
                    </a>
                </p>
            </div>

            <!-- Bottom Security Note -->
            <div class="pt-4 text-center text-xs text-slate-400">
                Protected by corporate SSO and security protocols.
            </div>
        </div>
    </div>
</div>
